<div class="proxy-management-wrapper">
  <button (click)="toggleProxyManagement()" [class]="toggleButtonClass" data-cy="proxy-management-toggle-button">
    <span [class]="toggleButtonArrowClass" data-cy="proxy-management-toggle-button-arrow"></span>
    <span class="toggle-button-label" data-cy="proxy-management-toggle-button-label">Proxy management</span>
  </button>
  @if (state.isOpen) {
    <div class="proxy-management-dropdown-wrapper">
      <div class="proxy-management-chip-input" data-cy="proxy-management-chip-input">
        <app-chip-input (addChip)="addProxy($event)"
          (chipsValues)="updateCurrentUserProxies($event)"
          (deleteChip)="deleteProxy($event)"
          [addRequestEnd]="addRequestEnd"
          [autocompleteConfiguration]="autocompleteConfiguration"
          [chipInputConfiguration]="proxyInputConfiguration"
          [deleteRequestEnd]="deleteRequestEnd"
          [inputType]="ChipInputTypeEnum.AUTOCOMPLETE"
          [resultTemplate]="dropdownItemTemplate"
        [tooltipTemplate]="chipTooltipTemplate"></app-chip-input>
        @if (spinnerObservable | async) {
          <div class="spinner-container">
            <app-loading-spinner class="center-spinner"></app-loading-spinner>
          </div>
        }
      </div>
    </div>
  }
</div>


<ng-template #dropdownItemTemplate let-result="result" let-term="term">
  <div class="proxy-management-template-item" data-cy="proxy-management-template-item">
    <div class="first line" data-cy="proxy-management-template-item-first-line">
      <ngb-highlight [term]="term"
      result="{{retrieveUserIdentificationLabel(result)}}"></ngb-highlight>
    </div>
    <div class="second line"
    data-cy="proxy-management-template-item-second-line">{{retrieveSupplyingPackingPlantsFromUser(result)}}</div>

  </div>
</ng-template>

<ng-template #chipTooltipTemplate let-context="context">
  @if (hasProxyDetailInfo(context)) {
    <ng-container *ngTemplateOutlet="chipTooltipUserDetailTemplate; context: {context: context}"></ng-container>
  } @else {
    <div data-cy="proxy-management-template-item-no-user-detail">{{userNoDetailTooltip}}</div>
  }
</ng-template>

<ng-template #chipTooltipUserDetailTemplate let-context="context">
  <div class="proxy-management-template-item">
    <div class="first line">{{retrieveUserIdentificationLabel(context)}}</div>
    <div class="second line">{{retrieveSupplyingPackingPlantsFromUser(context)}}</div>
  </div>
</ng-template>


